import React, { useState } from 'react'
import styled from 'styled-components'
import { Link } from 'react-router-dom'
import { toast } from 'react-toastify'
import { FormattedMessage, injectIntl } from 'react-intl'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import classNames from 'classnames'

import { API, API_ROUTER } from '../../api'

//
import Logo from '../../components/logo'
import authBg from '../../assets/images/fon.png'
import InputLogin from '../../components/UI/forms/input-logo_register'
import ButtonLogin from '../../components/UI/buttons/buttons-login_register'

import { isAuthenticated } from '../../helpers'
import { isConfirmPasswordCorrect, isPasswordValid } from '../../helpers'
import store from '../../redux/store'
import { getUserData, userOnline } from '../../redux/actions'

const NewPassword = props => {
  const getDefaultErrors = () => ({
    oldPassword: '',
    newPassword: '',
    confirmPassword: '',
  })
  function transformToAssocArray(paramString) {
    const params = {}
    const paramArray = paramString.split('&')
    for (let i = 0; i < paramArray.length; i++) {
      const tempArray = paramArray[i].split('=')
      params[tempArray[0]] = tempArray[1]
    }
    return params
  }
  const { secret } = getUrlParams()
  function getUrlParams() {
    const paramString = window.location.search.substr(1)
    return paramString != null && paramString !== ''
      ? transformToAssocArray(paramString)
      : {}
  }
  const [newPassword, setNewPassword] = useState('')
  const [oldPassword, setOldPassword] = useState('')

  const [confirmPassword, setConfirmPassword] = useState('')
  const [errors, setErrors] = useState(getDefaultErrors)

  const onSubmitAuth = e => {
    const { history } = props
    e.preventDefault()

    // validation
    errors.newPassword = isPasswordValid(newPassword)
    errors.oldPassword = isPasswordValid(oldPassword)

    errors.confirmPassword = isConfirmPasswordCorrect(
      newPassword,
      confirmPassword
    )
    setErrors({ ...errors })

    if (!Object.values(errors).some(value => value.length)) {
      const params = {
        ...API_ROUTER.auth.changePassword,
        data: {
          oldPassword: oldPassword,
          newPassword: newPassword,
        },
      }

      API.request(params, true)
        .then(() => {
          toast.success(
            <FormattedMessage id='changePassword.passwordChanged' />
          )
          props.getUserData()
          props.userOnline()

          // const userData = store.getState().userData;
          history.push(`/password/confirm`)
        })
        .catch(err => {
          toast.error((err?.data && err?.data?.message) || 'ERROR')
        })
    }
  }
  const onSubmitAfterEmail = e => {
    const { history } = props
    e.preventDefault()

    // validation
    errors.newPassword = isPasswordValid(newPassword)

    errors.confirmPassword = isConfirmPasswordCorrect(
      newPassword,
      confirmPassword
    )
    setErrors({ ...errors })

    if (!Object.values(errors).some(value => value.length)) {
      const params = {
        ...API_ROUTER.auth.confirmPassword,
        data: {
          secret: secret,
          password: newPassword,
          verify: confirmPassword,
        },
      }

      API.request(params, true)
        .then(() => {
          toast.success(
            <FormattedMessage id='changePassword.passwordChanged' />
          )
          // props.getUserData();
          // props.userOnline();

          // const userData = store.getState().userData;
          history.push(`/password/confirm`)
        })
        .catch(err => {
          toast.error((err?.data && err?.data?.message) || 'ERROR')
        })
    }
  }

  const onInputChange = type => {
    return e => {
      switch (type) {
        case 'newPassword':
          setNewPassword(e.target.value)
          break
        case 'oldPassword':
          setOldPassword(e.target.value)
          break
        case 'confirmPassword':
          setConfirmPassword(e.target.value)
          break
        default:
          return
      }
    }
  }
  return (
    <StyledAuth className={classNames('modalBg')}>
      <Logo />
      {isAuthenticated() ? (
        <>
          <p className='auth__text'>
            <FormattedMessage id='password.reset.resetPassword' />
          </p>
          <div className='back__login'>
            <Link to='/login'>
              <ButtonLogin type='button' active size='sm'>
                GO BACK
              </ButtonLogin>
            </Link>
          </div>
          <form className='auth__form' noValidate autoComplete='off'>
            <div className='input__group'>
              <div className='input__group__border' />
              <InputLogin
                type='password'
                placeholder='Old Password'
                icon='password'
                name='password'
                className='password__input'
                onChange={onInputChange('oldPassword')}
                error={errors.oldPassword}
                value={oldPassword}
              />
              <InputLogin
                type='password'
                placeholder='New Password'
                icon='password'
                name='password'
                className='password__input'
                onChange={onInputChange('newPassword')}
                error={errors.newPassword}
                value={newPassword}
              />
              <InputLogin
                type='password'
                placeholder='Repeat new Password'
                icon='password'
                name='password'
                className='password__input'
                onChange={onInputChange('confirmPassword')}
                error={errors.confirmPassword}
                value={confirmPassword}
              />
            </div>
          </form>
          <div className='back__login' style={{ marginTop: '42px' }}>
            <ButtonLogin type='button' active size='sm' onClick={onSubmitAuth}>
              <FormattedMessage id='password.reset.change' />
            </ButtonLogin>
          </div>{' '}
        </>
      ) : (
        <>
          <p className='auth__text'>
            <FormattedMessage id='password.reset.resetPassword' />
          </p>
          <div className='back__login'>
            <Link to='/login'>
              <ButtonLogin type='button' active size='sm'>
                <FormattedMessage id='password.reset.goBack' />
              </ButtonLogin>
            </Link>
          </div>
          <form className='auth__form' noValidate autoComplete='off'>
            <div className='input__group'>
              <div className='input__group__border' />
              <InputLogin
                type='password'
                placeholder='New Password'
                icon='password'
                name='password'
                className='password__input'
                onChange={onInputChange('newPassword')}
                error={errors.newPassword}
                value={newPassword}
              />
              <InputLogin
                type='password'
                placeholder='Repeat new Password'
                icon='password'
                name='password'
                className='password__input'
                onChange={onInputChange('confirmPassword')}
                error={errors.confirmPassword}
                value={confirmPassword}
              />
            </div>
          </form>
          <div className='back__login' style={{ marginTop: '42px' }}>
            <ButtonLogin
              type='button'
              active
              size='sm'
              onClick={onSubmitAfterEmail}
            >
              <FormattedMessage id='password.reset.change' />
            </ButtonLogin>
          </div>{' '}
        </>
      )}
    </StyledAuth>
  )
}
const mapDispatchToProps = dispatch => {
  return {
    getUserData: () => dispatch(getUserData()),
    userOnline: () => dispatch(userOnline()),
  }
}

export default injectIntl(
  withRouter(connect(() => {}, mapDispatchToProps)(NewPassword))
)

const StyledAuth = styled.div`
  padding: 85px 28px;
  background-size: cover;
  min-height: 100vh;
  & > .auth__text {
    text-align: center;
    margin: 42px 0;
    font-size: 16px;
    font-weight: bold;
    font-style: normal;
    letter-spacing: normal;
    line-height: normal;
  }

  & > .back__login {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 42px;
  }

  & > .auth__form {
    border: 1px solid #999999;
    padding: 48px 12px;
    border-radius: 16px;

    & > .input__group {
      border-radius: 16px;
      overflow: hidden;

      & > .input__group__border {
        border-top: 1px solid #999999;
      }
    }

    & > .btn__group {
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }

  @media (max-width: 400px) {
    padding: 50px 1rem;
  }
`
